import type {ReactElement} from 'react';
import React, {useRef} from 'react';
import styles from './drawer.module.scss';
import ClickableDiv from '@Components/clickable-div/clickable-div';
import {noop} from '@Utils/general.util';
import type {DrawerProps} from '@Components/drawer/drawer.types';
import {Direction} from '@Components/drawer/drawer.types';

export function Drawer({isOpen, className = '', onClose, children, overlay = true, direction = Direction.LEFT}: DrawerProps): ReactElement<DrawerProps> {
  const containerRef = useRef<HTMLDivElement>(null);
  const commonDraweClasses = 'bg-neutral-0 border-s-standard _no-border-top _no-border-left _no-border-bottom';
  const fixedDrawerClasses = '_position-fixed shadow-static-elevation-3';
  const nonFixedDrawerClasses = '_position-relative';

  const getDirectionClasses = (): string => {
    switch (direction) {
      case Direction.LEFT:
        return styles.fromLeft;
      case Direction.RIGHT:
        return styles.fromRight;
      default:
        return styles.fromLeft;
    }
  };

  return (
    <>
      <div
        ref={containerRef}
        className={`
        ${styles.drawerContainer} 
        ${getDirectionClasses()}
        ${isOpen ? styles.in : ''}
        ${commonDraweClasses}
        ${overlay ? fixedDrawerClasses : nonFixedDrawerClasses}
        ${className}
        `}
      >
        {isOpen ? children : null}
      </div>
      {isOpen && overlay ? <ClickableDiv className={styles.overlay} onClick={onClose ?? noop} /> : null}
    </>
  );
}
